import model                       from 'decorators/model';
import { Blamable }                from 'helpers/traits';
import { Timestampable }           from 'helpers/traits';
import moonSvg                     from 'icons/moon.svg';
import InterventionPrivateApiModel from '../../abstracts/InterventionPrivateApiModel';

@model.staticLabel('Tag')
@model.urnResource('tag')
export default class TagModel extends Blamable(Timestampable(InterventionPrivateApiModel)){
	public _filters: ModelFiltersExtended<{
		'tag.tagReference.reference': TagInterventionReference,
		'tag.tagValue.value': TagInterventionValue,
		'targetUrn': string,
	}> = {};
	public _sorts: ModelSortsExtended<unknown> = {};

	static get path(): string {
		return '/stonecode_tag_taggable_tags/{?id}';
	}

	public get targetUrn(): Urn {
		return this.get('targetUrn');
	}

	public get tagReference(): TagInterventionReference {
		return this.get('tagReference');
	}

	public get tagValue(): TagInterventionValue {
		return this.get('tagValue');
	}

	public get tagReferenceLabel(): string {
		switch (this.tagReference) {
			case 'no_signatory':
				return 'Aucun signataire';
			case 'schedule_option':
				return 'Option de planification';
			case 'block_status':
				return 'État du blocage';
			case 'rescheduling_from':
				return 'Replanification';
		}
	}

	public get tagValueLabel(): string {
		switch (this.tagValue) {
			case 'multi_day':
				return 'Intervention de nuit';
			default:
				return this.tagReferenceLabel;
		}
	}

	public getTagValueIcon() {
		switch (this.tagValue) {
			case 'multi_day':
				return moonSvg;
		}
	}
}
